import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props { aiRepository: AIRepository; }

@injectable()
export class GetAIEmailsByCustomerUseCase {
    _aiRepository: AIRepository;
    constructor(_: props) { this._aiRepository = _.aiRepository; }
    public call = async (query: any, type: string, params: string): Promise<any> => {
        return await this._aiRepository.getAIEmailsByCustomer(query, type, params);
    }
}
export const GetAIEmailsByCustomerUseCaseName = "GetAIEmailsByCustomerUseCaseName";
